/**
 * Sefira collection pill tabs — sync active state + horizontal scroll.
 */
(function () {
  'use strict';

  function normPath(url) {
    if (!url) return '';
    try {
      var base = window.location.origin;
      var u = url.indexOf('http') === 0 ? new URL(url) : new URL(url, base);
      return u.pathname.replace(/\/$/, '').toLowerCase();
    } catch (e) {
      return String(url).split('?')[0].replace(/\/$/, '').toLowerCase();
    }
  }

  function currentPath() {
    return window.location.pathname.replace(/\/$/, '').toLowerCase();
  }

  function syncRoot(root) {
    if (!root) return;
    var path = currentPath();
    var scroll = root.querySelector('[data-sefira-tabs-scroll]');
    var activeTab = null;

    root.querySelectorAll('.sefira-collection-tab').forEach(function (tab) {
      var link = tab.querySelector('a');
      if (!link) return;
      var href = normPath(link.getAttribute('href') || '');
      var on = href && href === path;
      tab.classList.toggle('is-active', on);
      if (on) {
        link.setAttribute('aria-current', 'page');
        activeTab = tab;
      } else {
        link.removeAttribute('aria-current');
      }
    });

    if (activeTab && scroll) {
      requestAnimationFrame(function () {
        var pad = 12;
        var sRect = scroll.getBoundingClientRect();
        var tRect = activeTab.getBoundingClientRect();
        if (tRect.left < sRect.left + pad) {
          scroll.scrollLeft += tRect.left - sRect.left - pad;
        } else if (tRect.right > sRect.right - pad) {
          scroll.scrollLeft += tRect.right - sRect.right + pad;
        }
      });
    }
  }

  function initAll() {
    if (!document.body.classList.contains('template-collection')) return;
    document.querySelectorAll('.sefira-collection-tabs-section').forEach(syncRoot);
  }

  window.SefiraCollectionTabs = { init: initAll, sync: syncRoot };

  initAll();
  document.addEventListener('DOMContentLoaded', initAll);
  window.addEventListener('load', initAll);
  window.addEventListener('pageshow', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
